<!-- OrderConfirmation.vue -->
<template>
  <div class="min-h-screen bg-background py-12">
    <div class="container mx-auto px-4">
      <div class="max-w-2xl mx-auto">
        <div class="text-center mb-8">
          <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
            </svg>
          </div>
          <h1 class="text-3xl font-bold text-foreground mb-2">Commande confirmée !</h1>
          <p class="text-muted-foreground">Merci pour votre commande #{{ orderId }}</p>
        </div>
        
        <div class="bg-card border border-border rounded-lg p-6 mb-6">
          <div class="space-y-4">
            <div class="flex justify-between">
              <span class="text-muted-foreground">Numéro de commande</span>
              <span class="font-medium">{{ orderId }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-muted-foreground">Date</span>
              <span class="font-medium">{{ new Date().toLocaleDateString() }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-muted-foreground">Total</span>
              <span class="text-lg font-bold">{{ total }} XAF</span>
            </div>
          </div>
        </div>
        
        <div class="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            @click="$router.push('/account')"
            class="bg-primary hover:bg-primary-hover text-primary-foreground font-semibold py-3 px-6 rounded-md transition-colors"
          >
            Voir mes commandes
          </button>
          <button
            @click="$router.push('/category')"
            class="border border-input bg-background hover:bg-accent hover:text-accent-foreground font-semibold py-3 px-6 rounded-md transition-colors"
          >
            Continuer mes achats
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderConfirmation',
  
  data() {
    return {
      orderId: this.$route.query.orderNumber || 'N/A',
      total: this.$route.query.total || 0
    }
  },
  
  mounted() {
    // Si pas d'ID de commande, rediriger
    if (!this.$route.query.orderId) {
      this.$router.push('/')
    }
  }
}
</script>